import {ErrorReferential} from "../../interfaces/error/error";

export const PERIMETER_ERROR: ErrorReferential = {
    REQUIRED_ACCOUNT: {id: "REQUIRED_ACCOUNT"},
    REQUIRED_COMPANY: {id: "REQUIRED_COMPANY"},
    REQUIRED_MERCHANTS: {id: "REQUIRED_MERCHANTS"}
}
